/* eslint-disable @khanacademy/ts-no-error-suppressions */
/**
 * Renders a button that has consistent hover behavior.
 *
 * The 'button' can be any React.Node.
 *
 * TODO(kevinb) cover more buttons
 * TODO(kevinb) add size classes so this can be used by the Pill
 */

import {css, StyleSheet, type CSSProperties} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

export type controlButtonColorsType = {
    color: string;
    hoveredColor: string;
};

type ControlButtonProps = {
    onClick?: () => unknown;
    children?: React.ReactNode;
    padding: number;
    colors: controlButtonColorsType;
    testId?: string;
    id?: string | null | undefined;
};

/**
 * @deprecated Use IconButton from @khanacademy/wonder-blocks-icon-button instead.
 */
export default class DeprecatedControlButton extends React.Component<ControlButtonProps> {
    static defaultProps: {
        colors: {
            color: string;
            hoveredColor: string;
        };
        padding: number;
    } = {
        padding: 0,
        colors: {
            color: color.offBlack32,
            hoveredColor: color.offBlack50,
        },
    };

    getClassFromProps(): CSSProperties {
        const {
            colors: {color, hoveredColor},
            padding,
        } = this.props;
        const propStyles = StyleSheet.create({
            button: {
                color: color,
                padding: padding,

                [":hover"]: {
                    color: hoveredColor,
                },

                [":focus"]: {
                    color: hoveredColor,
                },
            },
        });
        return propStyles.button;
    }

    render(): React.ReactNode {
        const {children, testId, id} = this.props;
        return (
            <button
                onClick={this.props.onClick}
                className={css(styles.resetButton, this.getClassFromProps())}
                data-testid={testId}
                // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
                id={id}
            >
                {children}
            </button>
        );
    }
}

const styles = StyleSheet.create({
    resetButton: {
        border: "none",
        background: "inherit",
        cursor: "pointer",
        lineHeight: 0,
    },
});
